import React from 'react'
import {
  MdCheckCircle as CheckIcon,
  MdTimelapse as TimeLapse,
  MdTimerOff as TimerOff
} from 'react-icons/md'
import {isPaymentComplete} from '@helpers/websites/tableOrders'

import styles from './styles.module.css'

const orderStatuses = {
  pending: {
    label: 'Por pagar',
    icon: <TimeLapse className={styles.orderPreview} size={13} color="#CC493C" />
  },
  done: {
    label: 'Pagado',
    icon: <CheckIcon size={13} color="#00CB8D" />
  },
  cancelled: {
    label: 'Cancelado',
    icon: <TimerOff size={13} color="#CC493C" />
  },
  _: {
    label: 'Por pagar',
    icon: <TimeLapse className={styles.orderPreview} size={13} color="#CC493C" />
  }
}

export default function Status(props) {
  const {order} = props
  const orderStatus = isPaymentComplete(order) ? orderStatuses.done : orderStatuses.pending

  return (
    <div className={styles.container}>
      <span>{orderStatus.label}</span>
      <span>{orderStatus.icon}</span>
    </div>
  )
}
